export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/sales.965b495.svg";